import type {
  EditInSeasonAggregationCriteriaSelection,
  EditInSeasonAggregationRequestBody,
  EditInSeasonAggregationSingleSelection,
  FrontendAssortmentDimensionAttributeAggregation,
  FrontendAssortmentRowDimensionIdentifier,
} from '../types';

import { isConcreteDimensionIdentifier } from './map-row-dimension-to-identifier';
import { transformDimensionAttributes } from './transform-dimensions';

type FrontendIncludeListSelection = Omit<
  EditInSeasonAggregationSingleSelection,
  'include_list'
> & {
  include_list: FrontendAssortmentRowDimensionIdentifier[][];
};

type FrontendCriteriaSelection = Omit<
  EditInSeasonAggregationCriteriaSelection,
  'exclude_list'
> & {
  exclude_list?: FrontendAssortmentRowDimensionIdentifier[][];
};

type RequestBody = Omit<
  EditInSeasonAggregationRequestBody,
  'dimensions' | 'selection'
> & {
  dimensions: FrontendAssortmentDimensionAttributeAggregation;
  selection: FrontendIncludeListSelection | FrontendCriteriaSelection;
};

const transformIdentifiers = (
  identifiers: FrontendAssortmentRowDimensionIdentifier[][],
) => identifiers.map((row) => row.filter(isConcreteDimensionIdentifier));

export const transformEditInSeasonAggregationRequest = (
  body: RequestBody,
): EditInSeasonAggregationRequestBody => {
  const { dimensions, selection, ...rest } = body;
  const transformedDimensions = transformDimensionAttributes(dimensions);

  if (selection.selection_type === 'include_list') {
    return {
      ...rest,
      dimensions: transformedDimensions,
      selection: {
        ...selection,
        include_list: transformIdentifiers(selection.include_list),
      },
    };
  }

  return {
    ...rest,
    dimensions: transformedDimensions,
    selection: {
      ...selection,
      exclude_list: selection.exclude_list
        ? transformIdentifiers(selection.exclude_list)
        : undefined,
    },
  };
};
